import { render, staticRenderFns } from "./PhysicalActivitiesAwayComp.vue?vue&type=template&id=0dc41896&scoped=true"
import script from "./PhysicalActivitiesAwayComp.vue?vue&type=script&lang=js"
export * from "./PhysicalActivitiesAwayComp.vue?vue&type=script&lang=js"
import style0 from "./PhysicalActivitiesAwayComp.vue?vue&type=style&index=0&id=0dc41896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc41896",
  null
  
)

/* custom blocks */
import block0 from "./PhysicalActivitiesAwayComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports